import * as R from 'ramda';

export const hubId = (typeof window === 'undefined') ? undefined : R.path(['_infl', 'hub', 'id'], window) || 'fakehubidfortest';
export const apiUrl = (typeof window === 'undefined') ? undefined : R.path(['_infl', 'api', 'url'], window);
export const serializedBrandingUrl = (typeof window === 'undefined') ? undefined : R.path(['_inflTheme', 'serializedBrandingUrl'], window);
export const lang = (typeof window === 'undefined') ? undefined : R.path(['_infl', 'hub', 'lang'], window);
